import PageHero from '../components/PageHero';
import { heroSubtitleClass, heroTitleClass, motionSafe } from '../constants/heroTypography';
import heroBg from '../assets/img/ic_our_service_background.png';

export default function Tours() {
  return (
    <div className="bg-navy-950">
      <PageHero
        title="Tours"
        subtitle="Curated local and international tour packages tailored to your plans."
        backgroundImage={heroBg}
        titleClassName={heroTitleClass}
        subtitleClassName={heroSubtitleClass(motionSafe)}
      />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <p className="text-justify leading-relaxed text-white/80">
          RAYAN STAR Consultancy can help you plan tours and travel experiences with clear itineraries, reliable
          partners, and support from enquiry through departure.
        </p>
      </section>
    </div>
  );
}
